export default __webpack_public_path__ + "static/media/kitchen-pack-5.c7986264.png";